import React from "react";
import  "../dashboard/mockteststyles.css";

export default function MockTestCircle(props) {
    return (
        <div  className="mt-5 md:mr-9 flex flex-col items-center hover:text-orange-500 max-sm:w-[25%]" >
            <div  className="flex flex-col items- center justify-center hover:text-orange-500 md:w-[120px] md:h-[120px] text-[3.3rem] max-sm:mr-2 max-sm:w-[70px] max-sm:h-[70px] max-sm:text-[2.3rem]" style={{
            borderRadius: "50%",
            backgroundColor: "#F8F9FA",
            border: "1.36px solid #FF6B00",
            color: "black",
             }}
            >
            <p className="text-center hover:text-orange-500 cursor-default">{props?.number}</p>
            </div>
                  
            <h1 className="black flex items-center justify-center text-center hover:text-orange-500 cursor-default text-[1.4rem]  max-sm:text-[0.7rem] ">{props.title}</h1>

        </div> 
    )
}